const EMAIL_BLOCKED_WIDGETS = [
  'eb-video', 'eb-countdown', 'eb-tabs', 'eb-accordion', 'eb-carousel',
  'eb-gallery', 'eb-google-maps', 'eb-counter', 'eb-animated-headline',
  'eb-flip-box', 'eb-progress-bar',
]

const NEWSLETTER_BLOCK_CATEGORIES = {
  'sect100': { label: 'Layout', order: 1 },
  'sect50':  { label: 'Layout', order: 1 },
  'sect30':  { label: 'Layout', order: 1 },
  'sect37':  { label: 'Layout', order: 1 },
  'text':       { label: 'Content', order: 2 },
  'text-sect':  { label: 'Content', order: 2 },
  'image':      { label: 'Content', order: 2 },
  'quote':      { label: 'Content', order: 2 },
  'button':     { label: 'Content', order: 2 },
  'divider':    { label: 'Content', order: 2 },
  'link':       { label: 'Content', order: 2 },
  'link-block': { label: 'Content', order: 2 },
  'grid-items': { label: 'Grid', order: 3 },
  'list-items': { label: 'Grid', order: 3 },
}

export default function elementorEmail(editor) {
  editor.on('load', () => {
    const bm = editor.BlockManager

    EMAIL_BLOCKED_WIDGETS.forEach(id => {
      const block = bm.get(id)
      if (block) bm.remove(id)
    })

    Object.entries(NEWSLETTER_BLOCK_CATEGORIES).forEach(([id, cat]) => {
      const block = bm.get(id)
      if (block) {
        block.set('category', cat)
      }
    })

    const blocksContainer = document.querySelector('.eb-blocks-container')
    if (blocksContainer) {
      blocksContainer.innerHTML = ''
      blocksContainer.appendChild(bm.render())
    }
  })
}

export { EMAIL_BLOCKED_WIDGETS }
